/**
 * Dependencies.
 */
import { BaseModel, endpoint } from '@prz-dp/services';

import AddressModel from '@/api/address/address.model';

/**
 * Export `CollectModel`.
 */
@endpoint('collect')
export default class CollectModel extends BaseModel {
  /**
   * Properties.
   */
  id: number;

  address: AddressModel;

  expectedCollectDate: string;

  numberPackages?: number;

  order: {
    client: {
      name: string;
    };

    code: string;

    trackingNumber: string;
  };

  /**
   * Constructor.
   */
  constructor(data: Partial<CollectModel>) {
    super(data);
  }
}
